export const locale = {
    lang: 'en',
    data: {
        NAV: {
            APPLICATIONS: 'Applications',
            ADMINISTRATIVE: {
                TITLE: 'Administrative',
                SHIPPING: {
                    TITLE: 'Shipping Company',
                    BADGE: '25',
                },
            },
            DASHBOARD: {
                TITLE: 'Dashboard',
            },
            CONSULT: {
                TITLE: 'Consult',
            },
            LOGISTIC: {
                TITLE: 'Logistic',
            },
            OPERATION: {
                TITLE: 'Operation',
            },
            REQUEST: {
                TITLE: 'Request',
            },
            CONCIERGE: {
                TITLE: 'Concierge',
            },
            REPORTS: {
                TITLE: 'Reports',
            },
            LOGOUT: {
                TITLE: 'Logout',
            },
        },
    },
};
